import React from 'react';
import Icon from 'components/AppIcon';

const STEPS = [
  { label: 'Workout', icon: 'Dumbbell' },
  { label: 'Goals', icon: 'Target' },
  { label: 'Diet', icon: 'Salad' },
];

export default function ProgressBar({ currentStep }) {
  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between relative">
        {/* Connector line */}
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-[var(--color-border)] z-0" />
        <div
          className="absolute top-5 left-0 h-0.5 bg-[var(--color-primary)] z-0 transition-all duration-500 ease-out"
          style={{ width: `${((currentStep - 1) / (STEPS?.length - 1)) * 100}%` }}
        />

        {STEPS?.map((step, idx) => {
          const stepNum = idx + 1;
          const isCompleted = stepNum < currentStep;
          const isActive = stepNum === currentStep;

          return (
            <div key={step?.label} className="flex flex-col items-center gap-2 z-10">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${
                  isCompleted
                    ? 'bg-[var(--color-primary)] border-[var(--color-primary)]'
                    : isActive
                    ? 'bg-[var(--color-background)] border-[var(--color-primary)] shadow-[0_0_0_4px_var(--color-primary)]/10'
                    : 'bg-[var(--color-background)] border-[var(--color-border)]'
                }`}
              >
                {isCompleted ? (
                  <Icon name="Check" size={16} color="#fff" strokeWidth={2.5} />
                ) : (
                  <Icon
                    name={step?.icon}
                    size={16}
                    color={isActive ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
                    strokeWidth={2}
                  />
                )}
              </div>
              <span
                className={`text-xs font-medium font-[var(--font-caption)] hidden sm:block ${
                  isActive
                    ? 'text-[var(--color-primary)]'
                    : isCompleted
                    ? 'text-[var(--color-foreground)]'
                    : 'text-[var(--color-muted-foreground)]'
                }`}
              >
                {step?.label}
              </span>
            </div>
          );
        })}
      </div>
      <p className="text-center text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)] mt-4">
        Step {currentStep} of {STEPS?.length}
      </p>
    </div>
  );
}
